import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8m11.5 3.5V7L8 3.5L4.5 7v4.5L8 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpChevronCircle
